// Component Name:  RFIDBlackListMgmt component
// Author: Lavanya S
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Date: 07-05-2025
// Reference: Original
// Description: This is a RFIDBlackListMgmt Modal component which . It is used to show the blacklisted rfid.
// Interfaces: Accepts props
// Maintenance History:  1.0 - First Version
import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Input, Label, ModalHeader, ModalBody } from "reactstrap";
import ReactModal from "react-modal";
import { modalStyleRFID } from "../Utility/styleComponents";
import LKCloseImg from "../../assets/images/LK_Icons/LK_Close.svg";
import LKSearchImg from "../../assets/images/LK_Icons/LK_Search.svg";
import LKArrowUpImg from "../../assets/images/LK_Icons/LK_Arrow up.svg";
import LKArrowDownImg from "../../assets/images/LK_Icons/LK_Arrow Down.svg";
import { connect } from "react-redux";

const RFIDBlackListMgmt = (props) => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [hoverRow, setHoverRow] = useState(null);
  const [searchRFID, setSearchRFID] = useState("");
  const [hasEntered, setHasEntered] = useState(false);
  const [RFID, setRFID] = useState([]);
  const [filteredRFID, setFilteredRFID] = useState([]);

  // const data = [
  //   { id: 1, name: "Lavanya", value: ["123324367AS12EFB", "234234ACAB983EFF", "123213369ACE74AA"] },
  //   { id: 2, name: "varshitha", value: ["234234ACAB983EFF", "123213369ACE74AA"] },
  // ];
  // console.log("data: ", props?.data);
  // console.log("RFID: ", RFID);
  // console.log("filteredRFID: ", filteredRFID);

  useEffect(() => {
    const parseData = props?.data?.map((item) => ({ id: item?.phoneNumber, name: item?.name, value: item?.rfids }));
    setRFID(parseData);
    setFilteredRFID(parseData);
  }, [props?.data]);

  useEffect(() => {
    if (searchRFID?.length > 0) {
      const searchByFilter = RFID?.filter((item) => {
        return item?.name?.toLowerCase()?.includes(searchRFID?.toLowerCase());
      });
      setFilteredRFID(searchByFilter);
    } else {
      RFID?.length > 0 && setFilteredRFID(RFID);
    }
  }, [searchRFID]);

  useEffect(() => {
    if (props.isModalOpen) {
      // wait a tick to allow modal to mount first, then apply enter animation
      setTimeout(() => setHasEntered(true), 100);
    } else {
      setHasEntered(false); // reset on close
    }
  }, [props.isModalOpen]);

  // handle row click
  const handleRowClick = (row) => {
    setSelectedRow(row);
  };

  // RFID row component and onclick expands to show rfid
  const rfidRow = (id, name, value) => {
    // console.log("Value", value);

    return (
      <>
        <Row
          className="my-2"
          style={{ cursor: "pointer", backgroundColor: hoverRow === id && "#EFEFEF" }}
          onClick={() => handleRowClick(id)}
          onMouseOver={() => setHoverRow(id)}
          onMouseLeave={() => setHoverRow(null)}
        >
          <Col className="border py-1">
            <img src={selectedRow === id ? LKArrowUpImg : LKArrowDownImg} alt="search" style={{ width: "10px", height: "10px", marginRight: "2px" }} />
            {/* {selectedRow === id ? <i className="ri-arrow-up-s-line"></i> : <i className="ri-arrow-down-s-line"></i>} */}
            {id}
          </Col>
          <Col className="border py-1">{name}</Col>
        </Row>
        <div
          style={{
            maxHeight: selectedRow === id ? "500px" : "0",
            overflow: "hidden",
            transition: "max-height 0.4s ease",
          }}
        >
          {value?.map(
            (item, index) =>
              selectedRow === id && (
                <Row key={index} className="ps-4 text-muted">
                  <Col>
                    <div className="d-flex align-items-center">
                      <span style={{ fontSize: "1.5rem", lineHeight: "1" }} className="mr-2">
                        ↳
                      </span>
                      <div className="d-flex align-items-center mt-2">
                        <span className="fw-bold mr-2">{index + 1}. </span>
                        <span>{item}</span>
                      </div>
                    </div>
                  </Col>
                </Row>
              )
          )}
        </div>
      </>
    );
  };

  var modalWidth = props.layoutType === "vertical" ? "30%" : "100%";
  var modalHeight = props.layoutType === "vertical" ? "100%" : "100%";
  return (
    <ReactModal isOpen={props.isModalOpen} onRequestClose={props.closeModal} style={modalStyleRFID(modalWidth, modalHeight, hasEntered)} closeTimeoutMS={400} ariaHideApp={false}>
      <div className="d-flex justify-content-between align-items-center px-3 mt-2 pb-3 border-bottom">
        <h5> RFID BLACKLIST </h5>
        <img src={LKCloseImg} alt="Close" onClick={props.closeModal} style={{ cursor: "pointer", width: "20px", height: "20px", marginLeft: "auto" }} />
      </div>

      <ModalBody>
        <div className="container mt-4">
          {/* search for name in rfid blacklist */}

          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                {/* <i className="ri-search-line"></i> */}
                <img src={LKSearchImg} alt="search" style={{ width: "14px", height: "14px", marginRight: "4px" }} />
              </span>
            </div>
            <input type="text" className="form-control" value={searchRFID} onChange={(e) => setSearchRFID(e.target.value)} />
            <div className="input-group-append">
              <span className="input-group-text" style={{ cursor: "pointer" }}>
                {/* <i className="ri-close-line"></i> */}
                <img src={LKCloseImg} alt="close" style={{ cursor: "pointer", width: "14px", height: "14px", marginRight: "4px" }} onClick={() => setSearchRFID("")} />
              </span>
            </div>
          </div>
          <Row>
            <Col className="border py-1 text-white" style={{ backgroundColor: "#005C8E" }}>
              <b>Id</b>
            </Col>
            <Col className="border py-1 text-white" style={{ backgroundColor: "#005C8E" }}>
              <b>Name</b>
            </Col>
          </Row>
          {filteredRFID?.length === 0 ? (
            <div style={{ textAlign: "center", marginTop: "10px" }}>No Data</div>
          ) : (
            filteredRFID?.map((item) => {
              return <div key={item?.id}>{rfidRow(item?.id, item?.name, item?.value)}</div>;
            })
          )}
        </div>
      </ModalBody>
    </ReactModal>
  );
};
const mapStateToProps = (state) => ({
  layoutType: state.Layout.layoutType,
});

export default connect(mapStateToProps)(RFIDBlackListMgmt);
